'use client';

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from '@/lib/utils';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn('relative flex w-full touch-none select-none items-center', className)}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-5 w-full grow rounded-full border-1 border-greyscale-300 bg-greyscale-200 focus-visible:outline-4 focus-visible:outline-solid focus-visible:outline-greyscale-400 focus-visible:outline-offset-0">
      <SliderPrimitive.Range className="absolute top-1/2 h-5 rounded-lg -translate-y-1/2 border-2 border-greyscale-1000 bg-secondary-brand" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="block h-7 w-7 rounded-full border-2 border-greyscale-1000 bg-greyscale-0 disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-4 focus-visible:outline-solid focus-visible:outline-greyscale-400 focus-visible:outline-offset-0" />
    <SliderPrimitive.Thumb className="block h-7 w-7 rounded-full border-2 border-greyscale-1000 bg-greyscale-0 disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-4 focus-visible:outline-solid focus-visible:outline-greyscale-400 focus-visible:outline-offset-0" />
  </SliderPrimitive.Root>
));

Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
